import React from 'react'
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../Utils/_helpers";
import { DropdownTopbarItemToggler } from "../../Utils/_partials/dropdowns";
import * as auth from "../modules/Auth/_redux/authRedux";
import { MultiSelectAll2 } from "../modules/Dashboard/pages/dashboard/dashboard-subheader/MutliSelectAll2Version2";
import { API_ENDPOINT_BASE_URL } from "../util/constants";
import * as helpers from "../util/helpers";
import { getPageFilters } from "../util/helpers";
import { InputGroupFilter } from "./InputGroupFilter";

const UserPlansFilters = (props) => {
  const dispatch = useDispatch();

  const formatSelectedOptions = (selectedOptions) => {
    const selectedOptionsList = [];

    selectedOptions.map((option, i) => {
      selectedOptionsList.push(option.value);
    });
    return selectedOptionsList;
  };

  const changePlansAndNumbers = (
    selectedPlanOptions,
    selectedNumberOptions
  ) => {
    let pageFilters = getPageFilters();

    pageFilters = { ...pageFilters };
    pageFilters.selectedPlansForCallLogs = formatSelectedOptions(
      selectedPlanOptions
    );
    pageFilters.selectedPlansOptionsForCallLogs = selectedPlanOptions;

    var changelog = {};
    changelog.selectedPlansForCallLogs = formatSelectedOptions(
      selectedPlanOptions
    );
    changelog.selectedPlansOptionsForCallLogs = selectedPlanOptions;
    pageFilters["changelog"] = changelog;

    pageFilters.selectedNumbersForCallLogs = formatSelectedOptions(
      selectedNumberOptions
    );
    pageFilters.selectedNumbersOptionsForCallLogs = selectedNumberOptions;

    changelog.selectedNumbersForCallLogs = formatSelectedOptions(
      selectedNumberOptions
    );
    changelog.selectedNumbersOptionsForCallLogs = selectedNumberOptions;

    const action = {
      type: auth.actionTypes.Set,
      payload: pageFilters,
    };
    dispatch(action);
    dispatch(
      auth.actions.CheckFiltersState({ filter_type: "callLogsFiltersState" })
    );

    const tempList = [];

    selectedPlanOptions.map((option, i) => {
      tempList.push(option.label);
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-12 flex-d">
          <div className="plan-entitydd sub-header-filter">
            <div className="custom-aligning-plans">
              <MultiSelectAll2
                type="plans"
                label="Plans"
                classNamePrefix="react-kis"
                changePlansAndNumbers={changePlansAndNumbers}
                inlineSearchPlaceholder="Search Number"
                clearFilterFlag={props.clearFilterFlag}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const resetCallLogs = (auth, dispatch, resetToDefaultDate) => {
  
  const changelog = {
    calllogsFiltersState: 0,
    clearSearchStateForCallLogs: 0,

    selectedNumbersForCallLogs: [],
    selectedPlansForCallLogs: [],
    selectedNumbersOptionsForCallLogs: false,
    selectedPlansOptionsForCallLogs: false,
    call_action: JSON.parse(JSON.stringify([...auth.i_call_action])),
    call_duration: JSON.parse(JSON.stringify([...auth.i_call_duration])),
    call_status: JSON.parse(JSON.stringify([...auth.i_call_status])),
    customer_status: JSON.parse(JSON.stringify([...auth.i_customer_status])),
    agent_status: JSON.parse(JSON.stringify([...auth.i_agent_status])),
    disposition: JSON.parse(JSON.stringify([...auth.i_disposition])),
    device: JSON.parse(JSON.stringify([...auth.i_device])),
    duration__lte_min_CallLogs: "",
    duration__lte_sec_CallLogs: "",
    applySearchStateForCallLogs:
      helpers.getAuthState().applySearchStateForCallLogs + 1,
    agent_names_call_logs_filter: [],
    compaigns: [],
    others: JSON.parse(JSON.stringify([...auth.i_others])),
  };

  const agent_names_call_logs_filter = helpers.getAllAgentsForCallLogsFilter();
  if (agent_names_call_logs_filter && agent_names_call_logs_filter.length > 0) {
    agent_names_call_logs_filter.map((s, i) => {
      s.selected = false;
    });
    changelog.agent_names_call_logs_filter = [...agent_names_call_logs_filter];
  }

  const compaigns = helpers.getAllCampaignsForCallLogs();
  if (compaigns && compaigns.length > 0) {
    compaigns.map((s, i) => {
      s.selected = false;
    });
    changelog.compaigns = [...compaigns];
  }

  const selectedSolutions = helpers.getSelectedSolutionsForCallLogs();
  if (selectedSolutions && selectedSolutions.length > 0) {
    selectedSolutions.map((s, i) => {
      s.selected = false;
    });
    changelog.selectedSolutionsForCallLogs = [...selectedSolutions];
  }

  const selectedDispositions = helpers.getSelectedDispositionsForCallLogs();
  if (selectedDispositions && selectedDispositions.length > 0) {
    selectedDispositions.map((s, i) => {
      s.selected = false;
    });
    changelog.disposition = [...selectedDispositions];
  }

  if (resetToDefaultDate) {
    changelog.date_filterForCallLogs = null;
    changelog.from_date_fmtForCallLogs = null;
    changelog.to_date_fmtForCallLogs = null;
  }

  dispatch(auth.actions.Clear({ changelog: changelog, module: "call-logs" }));
  dispatch(
    auth.actions.CheckFiltersState({ filter_type: "callLogsFiltersState" })
  );
  clearFlagIncrement(auth, dispatch);
};

export const clearFlagIncrement = (auth, dispatch) => {
  dispatch(
    auth.actions.clearIncrementFilterStateCounterForCallLogs({
      module: "call-logs",
    })
  );
};

export const CallLogsHeaderFilters = (props) => {
  const clearFilterFlag = useSelector((state) => {
    return state.auth.clearFilterStateCounterForCallLogs;
  });

  const myRefname = useRef(null);
  const dispatch = useDispatch();

  const callLogsFiltersState = useSelector((state) => {
    return state.auth.callLogsFiltersState;
  });

  const userSolutions = useSelector((state) => {
    return state.auth.solutions;
  });

  const handleClick = () => {
    myRefname.current.click();
  };

  const handleClearFilters = () => {
    resetCallLogs(auth, dispatch, false);
    handleClick();
    setPlanState("closed");
    setStatus(null);
    dispatch({ type: auth.actionTypes.UserPlans, payload: "" });
  };
  useEffect(()=>{
    dispatch({ type: auth.actionTypes.UserPlans, payload: "" });
  },[])
  const [status, setStatus] = useState(null);
  const MSG_DURATION_ERR = "Please enter a valid Call Duration";

  const handleApplySearch = () => {
    setStatus(null);
    const authState = helpers.getAuthState();
    let hasError = false;
    if (authState.call_duration) {
      authState.call_duration.map((a, i) => {
        if (a.value === "custom" && a.selected === true) {
          if (
            !authState.duration__lte_min_CallLogs &&
            !authState.duration__lte_sec_CallLogs
          ) {
            setStatus(MSG_DURATION_ERR);
            hasError = true;
          } else {
            const min = Number(authState.duration__lte_min_CallLogs);
            const sec = Number(authState.duration__lte_sec_CallLogs);

            if (isNaN(min) && isNaN(sec)) {
              setStatus(MSG_DURATION_ERR + "1");
              hasError = true;
              return;
            }

            let duration__lte = 0;
            if (!isNaN(min)) {
              duration__lte += 60 * min;
            }
            if (!isNaN(sec)) {
              duration__lte += sec;
            }

            if (duration__lte <= 0) {
              setStatus(MSG_DURATION_ERR);
              hasError = true;
              return;
            }
          }
        }
      });
    }

    if (hasError) {
      return;
    }
    dispatch(auth.actions.ApplySearch({ module: "call-logs" }));
    handleClick();
  };

  const [planState, setPlanState] = useState("closed");
  let selectedSolutionsForCallLogs = [];

  const is_disposition_enabled = useSelector((state) => {
    return state.auth.is_disposition_enabled;
  });

  useEffect(() => {
    const get = async () => {
      const temp = [];
      temp.push({ label: "All Dispositions", value: "all", selected: false });

      const response = await helpers.getDispositions();
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.dispositions
      ) {
        response.data.dispositions.map((d, i) => {
          temp.push({ label: d.name, value: d.id, selected: false });
        });

        const listKey = "disposition";

        let pageFilters = getPageFilters();
        pageFilters = { ...pageFilters };
        pageFilters[listKey] = temp;

        var changelog = {};
        changelog[listKey] = temp;
        pageFilters["changelog"] = changelog;

        const action = {
          type: auth.actionTypes.Set,
          payload: { ...pageFilters },
        };
        dispatch(action);
      }
    };
    if (is_disposition_enabled) {
      get();
    }
  }, []);

  useEffect(() => {
    const selectedSolutions = helpers.getSelectedSolutionOptionsForCallLogs();
    if (!selectedSolutions || selectedSolutions.length == 0) {
      if (userSolutions && userSolutions.length) {
        const temp = [];
        temp.push({ label: "All", value: "all", selected: false });
        userSolutions.map((solution, index) => {
          temp.push({
            label: solution.name,
            value: solution.id,
            selected: false,
          });
        });

        const listKey = "selectedSolutionsForCallLogs";

        let pageFilters = getPageFilters();
        pageFilters = { ...pageFilters };
        pageFilters[listKey] = temp;

        var changelog = {};
        changelog[listKey] = temp;
        pageFilters["changelog"] = changelog;

        const action = {
          type: auth.actionTypes.Set,
          payload: { ...pageFilters },
        };
        dispatch(action);
      }
    }
  }, [userSolutions]);

  const searchApi = async (queryString) => {
    const url = `${API_ENDPOINT_BASE_URL}/newsr/api/v1/order_list_fetch/`;
    const params = {};
    if (queryString && queryString != "") {
      params["order_id__exact"] = queryString;
    }
    const response = await axios.get(url, { params: params });
    return response;
  };

  const searchAllAgentsApi = async (queryString = '') => {
    const url = `${API_ENDPOINT_BASE_URL}/newsr/api/v1/agent/`;
    const params = {
      first_name__icontains: "",
      last_name__icontains: "",
      limit: 5,
    };

    if (queryString) {
      let index = queryString.indexOf(' ');
      if(index !== -1) {
        params.first_name__icontains = queryString.slice(0, index);
        params.last_name__icontains = queryString.slice(index,queryString.length).trim();
      } else {
        delete params.last_name__icontains;
        params.first_name__icontains = queryString;
      }
    }

    const response = await axios.get(url, { params: params });
    return response;
  };

  return (
    <>
      <Dropdown drop="down" className="logs-filter head-filter-dd">
        <Dropdown.Toggle
          as={DropdownTopbarItemToggler}
          id="dropdown-toggle-calendar-filter"
        >
          <div
            ref={myRefname}
            className="d-none d-lg-flex filter-btn pl-3 pr-1 pt-2 pb-2"
            onClick={() => {}}
          >
            <div className="inactive-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/inactive-filter-icon.svg")}
              />
            </div>
            <div className="active-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/active-filter-icon.svg")}
              />
            </div>
            <div className="mr-2">Filters</div>
            <div className="down-arrow">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/filter-down.svg")}
              />
            </div>
            <div className="up-arrow">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/filter-up.svg")}
              />
            </div>
          </div>
          <div
            ref={myRefname}
            className="d-flex d-lg-none mob-filter-btn filter-btn pl-3 pr-1 pt-2 pb-2"
          >
            <div className="inactive-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/inactive-filter-icon.svg")}
              />
            </div>
            <div className="active-ficon mr-2">
              <img
                alt=""
                src={toAbsoluteUrl("/media/sr/icons/active-filter-icon.svg")}
              />
            </div>
            <div className="mr-2">Filters</div>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="filter-dropdown-menu">
          <ul className="list-unstyled p-5 mb-0">
            <li classNamedd="title mb-1">
              <div
                className="mt-0 mb-0 mr-1"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  style={{ widths: "59px", fontSize: "12px" }}
                  className="sr-btn pl-6 pr-6 mr-3"
                  onClick={() => {
                    handleApplySearch();
                  }}
                  disabled={callLogsFiltersState == 200 ? false : true}
                >
                  Apply
                </Button>
                <Button
                  style={{ widths: "59px", fontSize: "12px" }}
                  className="outline-btn pl-6 pr-6"
                  onClick={handleClearFilters}
                >
                  Clear
                </Button>
              </div>
            </li>
          </ul>
          <div className="filter-divider"></div>
          {status && (
            <div className="filter-error-alert m-4">
              <div>
                <a
                  href="#!"
                  onClick={() => {
                    setStatus(null);
                  }}
                >
                  <img
                    alt=""
                    className="exclamation-icon"
                    src={toAbsoluteUrl("/media/sr/icons/error-exclamation.svg")}
                  />
                </a>
              </div>
              <div className="error-text">{status}</div>
            </div>
          )}

          <InputGroupFilter
            filter_key={"selectedSolutionsForCallLogs"}
            filter_title={"SOLUTIONS"}
            initialOpen={true}
          />
          <ul className="list-unstyled p-5 mb-0">
            <li className="title mb-1">
              {planState === "opened" && (
                <span className="mr-3">
                  <img
                    alt=""
                    onClick={() => {
                      setPlanState("closed");
                    }}
                    src={toAbsoluteUrl("/media/sr/icons/filter-minus.svg")}
                  />
                </span>
              )}
              {planState === "closed" && (
                <span className="mr-3">
                  <img
                    alt=""
                    onClick={() => {
                      setPlanState("opened");
                    }}
                    src={toAbsoluteUrl("/media/sr/icons/filter-plus.svg")}
                  />
                </span>
              )}

              <span
                className="sub-filter-title"
                style={{ verticalAlign: "middle" }}
              >
                PLANS
              </span>
            </li>
            {planState === "opened" && (
              <li>
                <UserPlansFilters clearFilterFlag={clearFilterFlag} />
              </li>
            )}
          </ul>
          <div className="filter-divider"></div>

          {(helpers.isAdmin() || helpers.isSuperVisor()) && (
            <InputGroupFilter
              filter_key={"agent_names_call_logs_filter"}
              filter_title={"AGENT NAME"}
              search={true}
              searchPlaceholder={"Agent Name"}
              clearFilterFlag={clearFilterFlag}
              searchApi={searchAllAgentsApi}
            />
          )}
          <InputGroupFilter
            filter_key={"compaigns"}
            filter_title={"CAMPAIGN ID"}
            search={true}
            searchPlaceholder={"Campaign ID"}
            clearFilterFlag={clearFilterFlag}
            searchApi={searchApi}
          />
          <InputGroupFilter
            filter_key={"call_action"}
            filter_title={"CALL ACTIONS"}
          />
          <InputGroupFilter
            type="single_select"
            filter_key={"call_duration"}
            filter_title={"CALL DURATION"}
          />

          <InputGroupFilter
            filter_key={"call_status"}
            filter_title={"CALL STATUS"}
          />
          <InputGroupFilter
            filter_key={"customer_status"}
            filter_title={"CUSTOMER STATUS"}
          />
          <InputGroupFilter
            filter_key={"agent_status"}
            filter_title={"AGENT STATUS"}
          />
          {is_disposition_enabled && (
            <InputGroupFilter
              filter_key={"disposition"}
              filter_title={"DISPOSITION"}
            />
          )}
          <InputGroupFilter
            filter_key={"device"}
            filter_title={"CALLING MODE"}
          />
          <InputGroupFilter filter_key={"others"} filter_title={"OTHERS"} />
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
